'use client'

import { Button } from '@vinted/web-ui'

import { useBrowserNavigation } from '@marketplace-web/browser/browser-navigation-util'
import { toUrlQuery } from '@marketplace-web/browser/url-util'

import { ADMIN_CATALOG_ITEM_URL } from '../../../constants/routes'

const Marketing = () => {
  const { searchParams } = useBrowserNavigation()

  const query = toUrlQuery({
    ...searchParams,
    marketing_use_allowed: 1,
    view: 'grid',
  })
  const url = `${ADMIN_CATALOG_ITEM_URL}/?${query}`

  return (
    <Button size={Button.Size.Small} inline url={url}>
      Show marketing use allowed items
    </Button>
  )
}

export default Marketing
